import { GameModel } from '@nolimitcity/slot-game/bin/model/GameModel';
import { ApiPlugin } from '@nolimitcity/slot-launcher/bin/plugins/ApiPlugin';
import { APIEvent } from '@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem';
import { APIFeatureBetEventData } from '@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData';
import { InitData } from '../data/InitData';
import { GameData } from '../data/GameData';
import { Beheaded } from '../../Beheaded';
import { SlotKeypad } from '@nolimitcity/slot-keypad/bin/SlotKeypad';
import { GameSetting } from '../../../core/setting/GameSetting';
import { BeheadedEngineManager } from '../../reels/BeheadedEngineManager';
import { IntroPresentation } from '../../presentations/IntroPresentation';

export class BaseModel extends GameModel<InitData, GameData> {
    public static buyFeatureName: string = '';
    public static featureBuy: boolean = false;
    private static api: ApiPlugin;

    constructor(_api: ApiPlugin) {
        super(_api);

        BaseModel.api = _api;

        this.gameData = new GameData();

        this.initData = new InitData();

        this.applyBelowStakeCheck(_api);

        Beheaded.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, () => {
            const activeBetFeature = SlotKeypad.apiPlugIn.betFeatureController.getActiveBetFeature();
            if (this.data.isRestoreState) return;

            const isBoostedBuy = activeBetFeature?.name == 'BOOSTED_BET';
            const isLevelThree = activeBetFeature?.name == 'FREESPIN';
            const isSuper = activeBetFeature?.name == 'SUPER_FREESPIN';
            const isLucky = activeBetFeature?.name == 'LUCKY_DRAW';

            // if (isSuper) {
            //     Beheaded.souldWildController.forceIndicatorResets();
            //     Beheaded.collectorBar.forceReset();

            //     Beheaded.souldWildController.enableSWindicator(5); //enable SW indicator at specified level
            //     Beheaded.collectorBar.resetAnimationLevel(5);
            //     Beheaded.overlayBG.upgradeBGOverlay(5);
            //     Beheaded.background.upgradeBG(5);

            //     BeheadedEngineManager.RSAll((reel,sym) => {
            //         sym.chargeSymbol();
            //     })
            // } else if (isLevelThree || isLucky) {
            //     Beheaded.souldWildController.forceIndicatorResets();
            //     Beheaded.collectorBar.forceReset();

            //     Beheaded.collectorBar.resetAnimationLevel(3);
            //     Beheaded.souldWildController.enableSWindicator(3); //enable SW indicator at specified level
            //     Beheaded.overlayBG.upgradeBGOverlay(3);
            //     Beheaded.background.upgradeBG(3);

            //     BeheadedEngineManager.RSAll((reel,sym) => {
            //         sym.deChargeSymbol(3);
            //         sym.chargeSymbol(3);
            //     })
            // } else
            Beheaded.souldWildController.disableIndicator(); //disable SW indicator
            Beheaded.overlayBG.flagShow(true);

            if (isBoostedBuy) {
                Beheaded.souldWildController.forceIndicatorResets();
                Beheaded.collectorBar.forceReset();

                Beheaded.souldWildController.enableSWindicator(1); //enable SW indicator at specified level
                Beheaded.collectorBar.resetAnimationLevel(1);
                Beheaded.overlayBG.upgradeBGOverlay(1);
                Beheaded.background.upgradeBG(1);
                BeheadedEngineManager.RSAll((reel, sym) => {
                    sym.deChargeSymbol(1);
                    sym.chargeSymbol(1);
                });
            } else {
                //disable xbet function
                Beheaded.collectorBar.resetAnimationLevel(0); //reset progress bar to level 0
                Beheaded.overlayBG.upgradeBGOverlay(0);
                Beheaded.background.upgradeBG(0);

                BeheadedEngineManager.RSAll((reel, sym) => {
                    sym.deChargeSymbol(0);
                });
            }
        });

        Beheaded.apiPlugin.events.once(APIEvent.FREE_FEATURE_BETS, (freeFeatureBets:APIFeatureBetEventData) => {
            IntroPresentation.introPlayed = true;
        });
        
    }

    private applyBelowStakeCheck(api: ApiPlugin): void {
        
        api.events.once('featureName', (data: string) => {
            BaseModel.buyFeatureName = data;
        });

        api.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
            this.onBet(betData);
        });

        api.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            this.onBet(betData);
        });

        this.gameData.Win.isWinBelowStake = () => this.isWinBelowStake;
        this.initData.Win.isWinBelowStake = () => this.isWinBelowStake;

        this.gameData.Win.isIndiviWinBelowStake = () => this.isIndiviWinBelowStake;
        this.initData.Win.isIndiviWinBelowStake = () => this.isIndiviWinBelowStake;
    }

    private onBet(betData: APIFeatureBetEventData): void {
        if(betData.type === "normalBet"){
            BaseModel.buyFeatureName = "";
            BaseModel.featureBuy = false
        }else{
            for (let index: number = 0; index < this.initData.featureBuyTimesBetValue.length; index++) {
                if (this.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    BaseModel.buyFeatureName = betData.featureName;
                    BaseModel.featureBuy = !!betData.playerInteraction;
                    break;
                }
            }
        }
    }

    private get getAccumulatedRoundWin(): number {
        return this.gameData?.Win.totalWin || this.initData.Win.totalWin;
    }

    public get isWinBelowStake(): boolean {
        return (
            BaseModel.api.gameClientConfiguration.belowStakeWinRestriction &&
            this.getAccumulatedRoundWin <= this.getBuyFeaturePrice
        );
    }

    public get isWinBelowStakeAllNoRestriction(): boolean {
        return this.getAccumulatedRoundWin <= this.getBuyFeaturePrice;
    }

    public get isIndiviWinBelowStake(): boolean {
        return (
            BaseModel.api.gameClientConfiguration.belowStakeWinRestriction &&
            this.gameData.Win.totalSpinWin / this.getBuyFeaturePrice <= 1
        );
    }

    public get getBuyFeaturePrice(): number {
        const betLevel: string = BaseModel.api.freeBets.hasFreeBets()
            ? BaseModel.api.freeBets.getBet()
            : BaseModel.api.betLevel.getLevel();
        let price: number = this.gameData?.Win.playedBetValue || parseFloat(betLevel);

        if (BaseModel.buyFeatureName) {
            for (let index: number = 0; index < this.initData.featureBuyTimesBetValue.length; index++) {
                if (this.initData.featureBuyTimesBetValue[index].name === BaseModel.buyFeatureName) {
                    price *= this.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    protected onInit(data: any): void {
        this.data = data;
        this.initData.setData(data);
        this.gameData.setData(data);
    }

    protected onGame(data: any): void {
        this.data = data;
        this.gameData.setData(data);
    }
}
